type BluecoinIconProps = {
  bodyColor: string;
  strokeColor: string;
  width?: number;
  height?: number;
  title?: string;
};

function BluecoinIcon(props: BluecoinIconProps): JSX.Element {
  const width = `${props.width}px` || '40px';
  const height = `${props.height}px` || '40px';
  // const viewBox = `0 0 ${props.width || 40} ${props.height || 40}`;
  const viewBox = `0 0 40 40`;
  return (
    <svg width={width} height={height} viewBox={viewBox}>
      {props.title && <title>{props.title}</title>}
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle fill={props.strokeColor} opacity="0.5" cx="20" cy="20" r="20" />
        <circle fill={props.bodyColor} cx="20" cy="20" r="10" />
      </g>
    </svg>
  );
}

export default BluecoinIcon;
